<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialpad Analytics Ai" class="d-icon d-icon--dialpad-analytics-ai" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="3.5" :fill="`url(#${uniqueID}a)`"/><path d="M13.499 8.49c.357.302.707.623 1.047.963 2.964 2.964 4.328 6.47 2.853 7.947-.866.865-2.427.767-4.225-.112a.433.433 0 0 1 .38-.777c1.503.735 2.7.81 3.234.277 1-1-.19-4.061-2.853-6.723a15.829 15.829 0 0 0-.993-.913.432.432 0 0 1 .557-.661Zm1.958 4.408a.432.432 0 0 1 .05.61c-.294.346-.615.693-.96 1.039-2.965 2.963-6.471 4.327-7.946 2.852-.865-.865-.768-2.424.11-4.222a.432.432 0 1 1 .776.38c-.734 1.502-.808 2.698-.275 3.231 1 1 4.06-.19 6.723-2.852.33-.33.634-.66.912-.988a.433.433 0 0 1 .61-.05ZM10.822 6.71a.433.433 0 0 1-.38.778c-1.502-.734-2.697-.809-3.23-.276-1 1 .19 4.06 2.852 6.724.322.322.653.626.99.91a.433.433 0 0 1-.556.661 16.71 16.71 0 0 1-1.046-.96C6.49 11.583 5.125 8.076 6.601 6.6c.864-.865 2.423-.768 4.221.11Zm1.2 3.79a.246.246 0 0 1 .178.18l.18.747c.03.129.129.232.257.267l.66.185a.227.227 0 0 1-.009.44l-.624.15a.367.367 0 0 0-.273.278l-.186.852a.24.24 0 0 1-.469 0l-.185-.85a.366.366 0 0 0-.274-.28l-.647-.152a.227.227 0 0 1-.17-.274.227.227 0 0 1 .16-.168l.65-.182a.366.366 0 0 0 .256-.26l.198-.758a.245.245 0 0 1 .299-.175ZM17.4 6.6c.865.867.768 2.431-.111 4.232a.432.432 0 1 1-.777-.38c.736-1.506.81-2.706.277-3.24-1.001-1-4.062.19-6.724 2.853-.324.323-.63.657-.916.997a.432.432 0 1 1-.661-.557c.301-.359.625-.71.966-1.052 2.963-2.963 6.47-4.328 7.946-2.852Z" fill="#fff"/><defs><linearGradient :id="`${uniqueID}a`" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse"><stop stop-color="#471571"/><stop offset=".031" stop-color="#551B84"/><stop offset=".145" stop-color="#7C229E"/><stop offset=".237" stop-color="#9024A4"/><stop offset=".355" stop-color="#B02290"/><stop offset=".483" stop-color="#D32B86"/><stop offset=".603" stop-color="#E92F6F"/><stop offset=".701" stop-color="#F6484F"/><stop offset=".9" stop-color="#FB7328"/><stop offset=".973" stop-color="#F3960F"/><stop offset="1" stop-color="#F3960F"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialpadAnalyticsAi',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
